export default __webpack_public_path__ + "static/equipment-link-9652f090ce56931200b250ee169e7531.jpg";